import { fetcher } from 'services/helpers/responseHandler'

const getDetails = subsidiaryId =>
  fetcher.post('merchants/subsidiary/load/config', { subsidiaryId })

const updateAsAdmin = (data, subsidiaryId) =>
  fetcher.post('merchants/update/subsidiary/byInternal', { ...data, subsidiaryId })

const updateAsUser = ({
  taxId,
  supportEmail,
  legalBusinessName,
  doingBusinessAsName,
  autoReplySettings,
  privacyUrl,
  termsUrl
}) =>
  fetcher.post('merchants/update/subsidiary/byExternal', {
    taxId,
    supportEmail,
    legalBusinessName,
    doingBusinessAsName,
    autoReplySettings,
    privacyUrl,
    termsUrl
  })

const getHotelGroups = (skip = 0, take = 100) =>
  fetcher.get('merchants/load/parents', { skip, take })

const registerCampaign = () => fetcher.post('telcosetup/campaign/registry')

const addHotel = model => fetcher.post('merchants/add/subsidiary', model)

const updateSubdomain = ({ userDefinedSubdomain }) =>
  fetcher.post('subsidiaries/subdomain', { customSubdomain: userDefinedSubdomain })

const messageResponseTimes = () =>
  fetcher.get('chat/retrieve/chat-message-response-times')

const hotelApi = {
  getDetails,
  updateAsAdmin,
  updateAsUser,
  getHotelGroups,
  registerCampaign,
  addHotel,
  updateSubdomain,
  messageResponseTimes
}

export default hotelApi
